import React from "react";
import Layout from "../../../Layout";
import HeaderReports from "../../HeaderReports";
import SearchMessageForwarding from "./SearchMessageForwarding";
import ListMessageForwarding from "./ListMessageForwarding";
import useUserStore from "../../../../utils/storeApp";

const MessageForwarding = () => {
  const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));

  return (
    <Layout>
     <HeaderReports />
      <ListMessageForwarding />
      <SearchMessageForwarding />
    </Layout>
  );
};

export default MessageForwarding;
